import {tt} from '../../../common/getTranslations';
import {CommentStatus} from '../../../common/shared/api/nicolas/vo/enums/CommentStatus.enum';
import {twMerge} from '../../../common/twMerge';
import {
  COMMENT_STATUS_MESSAGE,
  REPLY_COMMENT_STATUS_MESSAGE,
} from '../../../domain/comment/constant';
import {theme} from '../../../theme';
import {Divider} from '../../atoms/Divider/Divider';
import {Comment} from '../Comment/Comment';
import {CommentProfile} from '../Comment/CommentProfile';
import {CommentItemProps} from './CommentItemProps.interface';

export function CommentItem({
  item: {
    commentStatus,
    isSpoiler,
    isBest,
    userName,
    comment,
    likeCount,
    liked,
    myReplyCount,
    replyCount,
    emoticon,
    title,
    userThumbnailUrl,
    createDt,
  },
  isReply,
  isMyComment,
  shouldShowTempComment,
  shouldShowReply,
  onClickMore,
  onClickReply,
  onClickLike,
  onClickSpoilerVisible,
}: CommentItemProps) {
  // 댓글정보는 전혀 없이 댓글 상태만 표현해주는 경우를 의미합니다.
  const shouldShowOnlyStatusText =
    commentStatus === CommentStatus.DeletedByMe ||
    commentStatus === CommentStatus.BlockedByAdmin ||
    commentStatus === CommentStatus.BlockedByExid ||
    commentStatus === CommentStatus.Deleted ||
    (commentStatus === CommentStatus.Temp && !shouldShowTempComment);

  return (
    <>
      <div
        className={twMerge(
          'flex w-full space-x-12pxr py-20pxr px-18pxr',
          shouldShowOnlyStatusText && 'pl-66pxr'
        )}
      >
        {!shouldShowOnlyStatusText && (
          <CommentProfile
            isReply={isReply}
            profileImgUrl={userThumbnailUrl}
            isMyComment={isMyComment}
          />
        )}
        <Comment
          onlyText={
            shouldShowOnlyStatusText
              ? isReply
                ? REPLY_COMMENT_STATUS_MESSAGE[commentStatus]
                : tt(COMMENT_STATUS_MESSAGE[commentStatus])
              : undefined
          }
          isBestComment={isBest}
          isTemp={commentStatus === CommentStatus.Temp}
          isReply={isReply}
          isBlockedByUser={commentStatus === CommentStatus.BlockedByUser}
          isMyComment={isMyComment}
          emoticon={emoticon}
          nickname={userName}
          registrationDate={createDt}
          comment={comment}
          seriesText={isReply ? undefined : title}
          isLikeActive={liked}
          likeCount={likeCount}
          replyCount={replyCount}
          isReplyActive={shouldShowReply}
          hasMyReplyComment={!!myReplyCount && myReplyCount > 0}
          isSpoiler={isSpoiler || false}
          onClickMore={onClickMore}
          onClickReply={onClickReply}
          onClickLike={onClickLike}
          onClickSpoilerVisible={onClickSpoilerVisible}
          className="w-full"
        />
      </div>
      <div className={twMerge('pr-18pxr', isReply ? 'pl-94pxr' : 'pl-74pxr')}>
        <Divider
          color={theme.colors['theme-transparent-20']}
          sizePx={1}
          direction="horizontal"
          className="w-full"
        />
      </div>
    </>
  );
}
